const MessageBox = () => {
    return <>
        <button
            id="mbShowHiddenButton"
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#messageBoxModal"
        >
            Launch Message Box
        </button>
        <div
            className="modal fade"
            id="messageBoxModal"
            tabIndex={-1}
            aria-labelledby="messageBoxModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="messageBoxModalLabel">
                            Message
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body">

                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>
}

const showMessage = (message, title = "Message") => {
    var mbElement = document.getElementById("messageBoxModal");
    if (!mbElement) {
        console.error("Unable to find message box element");
        return;
    }
    const titleElement = mbElement.getElementsByClassName("modal-title")[0];

    if (titleElement) {
        titleElement.innerHTML = title;
    }

    const bodyElement = mbElement.getElementsByClassName("modal-body")[0];
    if (bodyElement) {
        bodyElement.innerHTML = message;
    }

    // Add event listener to clean up modal backdrop when message box closes
    mbElement.addEventListener('hidden.bs.modal', function cleanupModalBackdrop() {
        // Remove any remaining modal backdrops
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());
        
        // Reset body classes and styles
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        
        // Remove this event listener after cleanup
        mbElement.removeEventListener('hidden.bs.modal', cleanupModalBackdrop);
    }, { once: true });

    const btn = document.getElementById("mbShowHiddenButton");
    btn.click();
}

export {
    MessageBox,
    showMessage
};